import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const mixpanelEnabled = import.meta.env.VITE_REACT_APP_MIXPANEL_TOKEN ?? false;

export const trackPageView = () => {
	if (import.meta.env.VITE_NODE_ENV !== "development") {
		//console.info("Tracking page view", window.location.pathname);
	}
	if (mixpanelEnabled) {
		mixpanel.register({ "Page Name": window.location.pathname === "/" ? "Home" : window.location.pathname });
		mixpanel.track("Page View");
	}
};

export const trackLogin = (
	user = {
		id: null,
		first_name: null,
		last_name: null,
		company_name: null,
		is_2fa_enabled: null,
		role: null,
	},
) => {
	if (mixpanelEnabled) {
		// console.info("Tracking login", user);
		mixpanel.identify(user.id);
		mixpanel.people.set({
			$first_name: user.first_name,
			$last_name: user.last_name,
			$company_name: user.company_name,
			$user_role: user.role,
			"2fa_enabled": user.is_2fa_enabled,
		});
		mixpanel.track("Login");
	}
};

export const useMixpanelTrackPageViews = () => {
	const location = useLocation();

	useEffect(() => {
		if (mixpanelEnabled) {
			trackPageView();
		}
	}, [location]);
	return mixpanel;
};

/**
 * Track clicks with Mixpanel
 * @param {text} cssSelector - css selector
 * @param {text} eventName - the data to send to mixpanel e.g. "Click X Link"
 * @param {callback} fn - function callback
 */
export const trackClicks = (cssSelector, eventName, fn) => {
	if (mixpanelEnabled) {
		if (fn) {
			fn();

			if (import.meta.env.VITE_NODE_ENV !== "development") {
				console.log(eventName);
				console.log(fn);
			}
			//mixpanel.track_links(cssSelector, eventName, fn);
		} else {
			console.log(cssSelector);
			//mixpanel.track_links(cssSelector, message);
		}
	}
};

export const trackEvent = (eventName, data) => {
	if (mixpanelEnabled) {
		mixpanel.track(eventName, data);
	}
};
